import React from 'react';
import {useScoringRun} from '../../../context/ScoringRunContext';
import {useCustomer} from '../../../hooks/api/metadata';
import {resolveField} from '../../../shared/fields/keyplay';
import {AccountFieldOrCustomField} from '../../../shared/signalDefinition';
import {filterNull} from '../../../shared/util';
import {FilterSelect} from './FilterSelect';
import {FilterControlWithNegate} from './FilterControlWithNegate';
import _ from 'lodash';

export const IntentSignalsFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
}: {
  value: AccountFieldOrCustomField[];
  negate?: boolean;
  onChange: (value: AccountFieldOrCustomField[], negate?: boolean) => void;
  onRemove: () => void;
}) => {
  const intentModel = useScoringRun()?.intentModels?.[0];
  const {fieldDefinitions} = useCustomer();

  const intentFieldOptions = React.useMemo(() => {
    if (!intentModel) {
      return [];
    }

    return filterNull(
      intentModel.fieldsWithWeights.map(({field}) => {
        const resolved = resolveField(field, fieldDefinitions ?? []);
        if (!resolved) {
          return null;
        }
        return {
          value: field,
          label: resolved.label,
        };
      })
    );
  }, [intentModel, fieldDefinitions]);

  const selectedOptions = React.useMemo(
    () =>
      intentFieldOptions.filter((opt) =>
        value.find((v) => _.isEqual(v, opt.value))
      ),
    [value, intentFieldOptions]
  );

  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          isMulti
          options={intentFieldOptions}
          onChange={(values) => onValueChange(values.map((v) => v.value))}
          value={selectedOptions}
          noOptionsMessage={() => 'No intent signals available'}
        />
      )}
    </FilterControlWithNegate>
  );
};
